export default __webpack_public_path__ + "images/gw-footer-image.png?852cf7323239a1f569ebba4ce8d3637e";